import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../page/layout/HomeLayout.vue' //公共组件


Vue.use(Router);

export const constantRouterMap = [
    {
        path: '/',
        component: () => import('../page/LoginPage.vue'),
        hidden: true
    },
    {
        path: '/404',
        component: () => import('../page/404.vue'),
        hidden: true
    },
    {
        path: '/loginAccountSpecialGuest',
        component: () => import('../page/LoginPage.vue'),
        hidden: true
    },
    {
        path: '/client',
        component: () => import('../page/LoginPage.vue'),
        hidden: true
    },
    {
        path: '/oauthCallback',
        component: () => import('../page/OauthCallback.vue'),
        hidden: true
    },
    {
        path: '/admin',
        component: () => import('../page/MFALogin.vue'),
        hidden: true
    },
    {
        path: '/changePassword',
        component: () => import('../page/ChangePassword.vue'),
        hidden: true
    },
    {
        path: '/forgotPassword',
        component: () => import('../page/ForgotPassword.vue'),
        hidden: true
    },
    {
        path: '/activateAccount',
        component: () => import('../page/ActivateAccount.vue'),
        hidden: true
    },
    {
        path: '/',
        name: 'deloitteAdmin',
        component: Layout,
        meta: {
            title: 'deloitteAdmin'
        },
        children: [
            {
                path: 'companyList',
                name: 'companyList',
                component: () => import('../page/DeloitteAdmin/EngagementManagement/CompanyList.vue'),
                meta: {
                    title: 'Company Management',
                    keepAlive: false
                },
            },
            {
                path: 'packageList',
                name: 'packageList',
                component: () => import('../page/DeloitteAdmin/PackageManagement/PackageList.vue'),
                meta: {
                    title: 'Package Management',
                    keepAlive: false
                },
            },
            {
                path: 'packagePreview',
                name: 'packagePreview',
                component: () => import('../page/DeloitteAdmin/PackageManagement/PackagePreview.vue'),
                meta: {
                    title: 'Package Preview',
                    keepAlive: false
                },
            },
            {
                path: 'subModule',
                name: 'subModule',
                component: () => import('@/page/DeloitteAdmin/ModuleManagement/ModuleList.vue'),
                meta: {
                    title: 'Module',
                    keepAlive: false
                },
            },
            {
                path: 'subQuestion',
                name: 'subQuestion',
                component: () => import('@/page/DeloitteAdmin/QuestionnaireManagement/QuestionList.vue'),
                meta: {
                    title: 'Question',
                    keepAlive: false
                },
            },
            {
                path: 'engagementManagementList',
                name: 'engagementManagementList',
                component: () => import('../page/DeloitteAdmin/EngagementManagement/EngagementList.vue'),
                meta: {
                    title: 'Engagement Management',
                    keepAlive: false
                },
            },
            {
                path: 'moduleList',
                name: 'moduleList',
                component: () => import('@/page/DeloitteAdmin/ModuleManagement/ModuleList.vue'),
                meta: {
                    title: 'Module Engine',
                    keepAlive: false
                },
            },
            {
                path: 'questionList',
                name: 'questionList',
                component: () => import('@/page/DeloitteAdmin/QuestionnaireManagement/QuestionList.vue'),
                meta: {
                    title: 'Questionnaire Detail',
                    keepAlive: false
                },
            },
            {
                path: 'securityAccess',
                name: 'securityAccess',
                component: () => import('../page/DeloitteAdmin/SecurityAccess/SecurityAccess.vue'),
                meta: {
                    title: 'Security Access',
                    keepAlive: false
                },
            },
            {
                path: 'systemManagement',
                name: 'systemManagement',
                component: () => import('../page/DeloitteAdmin/SystemManagement/SystemManagement.vue'),
                meta: {
                    title: 'System Management',
                    keepAlive: false
                },
            },
            {
                path: 'aiChat',
                name: 'aiChat',
                component: () => import('../page/DeloitteAdmin/AiChat/Index.vue'),
                meta: {
                    title: 'AI Chat',
                    keepAlive: false
                },
            },
        ]
    },
    {
        path: '/clientAdmin',
        name: 'clientAdmin',
        component: Layout,
        meta: {
            title: 'clientAdmin'
        },
        children: [
            {
                path: 'home',
                name: 'home',
                component: () => import('../page/ClientAdmin/Home/index.vue'),
                meta: {
                    title: 'Home',
                    keepAlive: false
                },
            },
            {
                path: 'engagementInfo',
                name: 'engagementInfo',
                component: () => import('../page/ClientAdmin/EngagementInfo/index.vue'),
                meta: {
                    title: 'EngagementInfo',
                    keepAlive: false
                },
            },
        ]
    },
    {
        path: '/clientPage',
        name: 'clientPage',
        component: Layout,
        meta: {
            title: 'clientPage'
        },
        children: [
            {
                path: 'engagement',
                name: 'engagement',
                component: () => import('../page/Participant/EngagementManagement/EngagementList.vue'),
                meta: {
                    title: 'Engagement',
                    keepAlive: false
                },
            },
            {
                path: 'participant',
                name: 'participant',
                component: () => import('../page/Participant/Home/Index.vue'),
                meta: {
                    title: 'Participant',
                    keepAlive: false
                },
            },
            {
                path: 'detail',
                name: 'detail',
                component: () => import('@/page/Participant/QuestionPage/Index.vue'),
                meta: {
                    title: 'Detail',
                    keepAlive: false
                },
            },
            {
                path: 'engagementDetail',
                name: 'engagementDetail',
                component: () => import('../page/Participant/Home/Index.vue'),
                meta: {
                    title: 'Engagement Detail',
                    keepAlive: false
                },
            },
        ]
    },
];


export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
})

